module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [(_vm.authUser && _vm.authUser.role == 'superuser') ? _c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n      This is your company administrator console. Here you can configure\n      "), (_vm.authUser && _vm.authUser.role != 'shift_leader') ? _c('span', [_vm._v(" your company, users, roles, ")]) : _vm._e(), _vm._v("\n      data.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.fields), function(value, index) {
    return _c('div', {
      staticClass: "col-md-3 text-left"
    }, [_c('b-table', {
      staticClass: "my-table",
      attrs: {
        "striped": "",
        "hover": "",
        "fields": value,
        "items": _vm.items[index]
      },
      scopedSlots: _vm._u([{
        key: "name",
        fn: function(item) {
          return [_c('router-link', {
            staticClass: "link",
            attrs: {
              "to": item.item.url
            }
          }, [_vm._v(_vm._s(item.item.name))])]
        }
      }], null, true)
    })], 1)
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c686fd5e","hasScoped":false}!./src/components/home/home.component.html
// module id = 553
// module chunks = 1